/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_sq.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions SQ */
HafasWebapp.prototype.subscriptions.sq = function (_me) {
  // SQ-Events -------------------------------------------------------------------------------------------------------
  // Stationssuche Formular abschicken
  Hafas.ps.sub('/sq/postForm', Hafas.bind(_me.Controller.SQ.postForm, _me));

  // EU Spirit
  if (Hafas.Config.Switches.useEuSpirit) {
    Hafas.ps.sub('/sq/changeEUSpiritOption', Hafas.bind(_me.Controller.SQ.changeEUSpiritOption, _me));
    Hafas.ps.sub('/sq/setLocation', Hafas.bind(_me.Controller.SQ.setEuSpiritOption, _me));
  }

  // Stationssuche Suggest auswahl
  Hafas.ps.sub("/suggest/selectitem/Station", Hafas.bind(_me.Controller.SQ.setLocationFromSuggest, _me));

  Hafas.ps.sub('/suggest/setLocation', Hafas.bind(function (id, loc) {
    if (typeof id === 'string' && loc !== null && typeof loc === 'object' && id.startsWith('Station')) {
      Hafas.bind(_me.Controller.SQ.setLocationFromSuggest, _me)(loc);
    }
  }, _me));

  Hafas.ps.sub('/suggest/setProviderCtx/SQ', Hafas.bind(function (prvId, suggestId) {
    Hafas.bind(_me.Controller.SQ.changeEUSpiritOption,_me)({type:suggestId, value:prvId});
  }, _me));

  Hafas.ps.sub('/sq/setLocation/webapp', Hafas.bind(_me.Controller.SQ.setLocation, _me));
  Hafas.ps.sub('/sq/selectStopFromNearList', Hafas.bind(_me.Controller.SQ.selectStopFromNearList, _me));
  Hafas.ps.sub('/sq/setProductFormFilter', Hafas.bind(_me.Controller.SQ.setProductFormFilter, _me));
  Hafas.ps.sub('/sq/removeStopFromNearList', Hafas.bind(_me.Controller.SQ.removeStopFromNearList, _me));
  Hafas.ps.sub('/sq/favorites/selectStopFromNearList/showPopover', Hafas.bind(_me.Controller.SQ.showStopFromNearListPopover, _me));
  Hafas.ps.sub('/sq/favorites/selectStopFromNearList/closePopover', Hafas.bind(_me.Controller.SQ.hideStopFromNearListPopover, _me));
  Hafas.ps.sub('/favorites/closeLocationPopover', Hafas.bind(_me.Controller.SQ.hideStopFromNearListPopover, _me));


  if (Hafas.Config.Switches.useStationboard && Hafas.Config.SQ.useSmartDeparture === true) {
    Hafas.ps.sub('/favorites/update', Hafas.bind(_me.Controller.SQ.rerenderLinesNearby, _me));
  }
  if (Hafas.Config.Switches.useStationboard && Hafas.Config.SQ.useProductResultFilter === true) {
    Hafas.ps.sub('/sq/setProductResultFilter', Hafas.bind(_me.Controller.SQ.updateResultProductFilter, _me));
  }

  Hafas.ps.sub('/SQ/options/init', Hafas.bind(_me.Controller.SQ.initDirection, _me));

  Hafas.ps.sub("/sq/clearInput", Hafas.bind(_me.Controller.SQ.clearInput, _me));

  // Stationssuche Produktauswahl
  Hafas.ps.sub("/sq/selectProduct", Hafas.bind(function (pCls, boolval) {
    _me.Controller.SQ.instance.setProductClass(parseInt(pCls), boolval);
    _me.Controller.SQ.options.setProduct(pCls, boolval);
    Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);
    Hafas.ps.pub('/app/events/resize');
  }, _me));

  // Auswahl alle Produkt für Fahrplanauskunft
  Hafas.ps.sub("/sq/setAllProducts", function (onOrOff, parameter) {
    _me.Controller.SQ.setAllProducts(onOrOff);
  });

  // Stationssuche Time Mode
  Hafas.ps.sub("/sq/toggleTimeMode", Hafas.bind(_me.Controller.SQ.toggleTimeMode, _me));
  // Stationssuche Sort Mode
  Hafas.ps.sub("/sq/toggleSortMode", Hafas.bind(_me.Controller.SQ.toggleSortType, _me));
  Hafas.ps.sub('/sq/setDirection', Hafas.bind(_me.Controller.SQ.setDirection, _me));

  // Geolocation Aktivierung (z.B. bei Alltype)
  Hafas.ps.sub('/common/currentPositionActivated/Station', Hafas.bind(function (data) {
    this.Controller.SQ.instance.setLocation(data);
  }, _me));

  Hafas.ps.sub('/sq/requestError', Hafas.bind(function () {
    var button = Hafas('[name="submitSQForm"]');
    if (button) button.disabled = '';
  },_me))

  /* Datumsauswahl Stationboard*/
  Hafas.ps.sub('/sq/setDate', Hafas.bind(_me.Controller.SQ.setDate, _me));
  Hafas.ps.sub('/sq/setTime', Hafas.bind(_me.Controller.SQ.setTime, _me));

  /* sollte nicht mehr notwendig sein, da im options-Modul gekapselt /mroe */
  /* Auswahl Anzahl Fahrten */
  /**Hafas.ps.sub('/sq/setSelectOption',
   Hafas.bind(_me.Controller.SQ.setOption,_me));  **/

  // Funktionalität für Favoriten-Stern in der Stationsübersicht
  Hafas.ps.sub('/sq/addStopToFav', Hafas.bind(_me.Controller.SQ.addStopToFav, _me));
  Hafas.ps.sub('/sq/removeStopFromFav', Hafas.bind(_me.Controller.SQ.removeStopFromFav, _me));


  // Allgemeines Rendern der Tabs. Achtung: "webapp" ist die ID der allg. stboard.id
  Hafas.ps.sub('/sq/dataChanged/webapp', Hafas.bind(_me.Controller.SQ.renderStationboardTabs, _me));
  Hafas.ps.sub('/sq/refresh', Hafas.bind(_me.Controller.SQ.refresh, _me));

  Hafas.ps.sub('/sq/toggleDepArr', Hafas.bind(function (type) {
    if (type == "departure") {
      _me.Controller.SQ.instance.setBoardType("dep");
    }
    else if (type == "arrival") {
      _me.Controller.SQ.instance.setBoardType("arr");
    }
  }, _me));

  Hafas.ps.sub('/sq/setBoardType', Hafas.bind(function (type) {

    // ggf. blaetter-zaehler resetten
    if ((typeof _me.Controller.GUI.sq != 'undefined') && (typeof _me.Controller.GUI.sq.scroll != 'undefined')) {
      delete _me.Controller.GUI.sq.scroll;
    }
    _me.Controller.SQ.instance.setBoardType(type);

  }));

  /* Autorefresh vom Stationboard abschalten */
  Hafas.ps.sub('/app/switchContext', Hafas.bind(_me.Controller.SQ.stopAutorefresh, _me.Controller.SQ));


  /* Beim Wechsel von einem anderen Kontext zu SQ */
  Hafas.ps.sub('/app/contextChanged/SQ', Hafas.bind(_me.Controller.SQ.contextChangedToSQ,_me));

  /* Wenn Abfahrten geklickt wird, obwohl man schon in SQ ist */
  Hafas.ps.sub('/app/switchContextNoChange', Hafas.bind(_me.Controller.SQ.reEnterContext,_me));

  Hafas.ps.sub('/app/events/closeResults', Hafas.bind(function (data) {
    if (data.appcontext == 'SQ') {
      this.stopAutorefresh();
    }
  }, _me.Controller.SQ));

  // SQ select from DateTimePicker
  Hafas.ps.sub('/dateTimePicker/selectDateTime/SQ_DTP', Hafas.bind(_me.Controller.SQ.selectDateTimeFromPicker, _me));

  // Stops near
  Hafas.ps.sub('/sq/getStopsNearby', Hafas.bind(_me.Controller.SQ.getLocationsNear, _me));

  // Switch to SQ Module from Map Toolbox
  Hafas.ps.sub('/sq/fromMapPos', function (data) {
    // Tracking
    Hafas.ps.pub('/tracking/event/mapflyout-stationboard-pressed', [{
      typ: 'event',
      key: 'mapflyout-stationboard-pressed'
    }]);

    // Hide edit smartLocation view if opened and show form
    Hafas.ps.pub('/favorites/smartLocations/closeView');
    Hafas.ps.pub('/GUI/form/show', [{}]);

    Hafas.bind(_me.Controller.GUI.map.hide, _me)();
    Hafas.bind(_me.Controller.SQ.searchFromOtherContext, _me)(data);
    Hafas.ps.pub('/GUI/common/pageContentToggle',[{trigger: 'sub'}])
  });

  Hafas.ps.sub('/sq/searchFromOtherContext', Hafas.bind(_me.Controller.SQ.searchFromOtherContext, _me));

  Hafas.ps.sub('/GUI/leaveContext/SQ', Hafas.bind(_me.Controller.SQ.cleanup, _me));
  Hafas.ps.sub('/GUI/closeView/SQ', Hafas.bind(_me.Controller.SQ.closeView, _me));
  Hafas.ps.sub('/GUI/restoreView/SQ', Hafas.bind(_me.Controller.SQ.restoreView, _me));

  // show further results (blaettern)
  Hafas.ps.sub('/sq/getFurtherResults', Hafas.bind(_me.Controller.SQ.getFurtherJourneys, _me));

  // Aktualisierung der GUI beim Entfernen der Richtungs-Option
  Hafas.ps.sub('/sq/clearDirection/webapp', Hafas.bind(function () {
    _me.Controller.SQ.inpDir.resetLocation();
    _me.Controller.SQ.options.setRandomParameter("HFS_SQDirection", "value", "");
    Hafas.ps.pub('/options/gui/toggle/delete', [{id: "HFS_SQDirection", visibility: false}]);
  }, _me));

  Hafas.ps.sub('/sq/options/activateLocalStorage', Hafas.bind(_me.Controller.SQ.setOptionStorageActive,_me));

  Hafas.ps.sub('/sq/options/activateLocalStorageSort', Hafas.bind(_me.Controller.SQ.setSortOptionStorageActive,_me));

  // Stboard Anzeige in der Toolbox
  Hafas.ps.sub('/GUI/sq/toggleMiniStboard', Hafas.bind(_me.Controller.SQ.toggleMiniStboard, _me));

  Hafas.ps.sub('/sq/printSearchLink', Hafas.bind(_me.Controller.SQ.printSearchLink, _me));

  // Info Tab
  Hafas.ps.sub('/sq/infoTab/mapCoverClicked', Hafas.bind(_me.Controller.SQ.showMapToolboxForStation, _me));

  Hafas.ps.sub('/sq/setPlatform', Hafas.bind(_me.Controller.SQ.setPlatform,_me));

  // Send Meta Information
  if (Hafas.Modules.IFrameApi && Hafas.Config.Switches.useMetaDataApi) {
    // Send Metadata info for result page
    Hafas.ps.sub('/sq/dataChanged/webapp', Hafas.bind(function(){
      _me.Controller.App.sendMetaInformation("SQ","showResult",{
          location: {
            name: _me.Controller.SQ.instance.station.name
          }
      });
    }, _me));
  }
};
